import ButtonIcon from "components/button-icon";
import IconStop from "components/icons/stop.icon";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import ModalConfirmRefusal from "./modal-confirm-refusal";
import { useOrderVolumeContext } from "features/order-volume/context";
import { useGlobalContext } from "hooks/useGlobalContext";
import { getUserId } from "utils/user";

interface IOrderVolumeResuseProps {
  refresh: (newFilter?: any) => Promise<void>;
  volumeOrdersIds: number[];
  volumeOrders: any
}

export interface IAdditionalDataForRefusal {
  Observacao: string | null;
  TypeJustificationSuggestionManual: number | null;
}

const OrderVolumeRefuse = ({ refresh, volumeOrdersIds, volumeOrders }: IOrderVolumeResuseProps) => {
  const { setLoading } = useOrderVolumeContext();
  const { startOperation } = useGlobalContext();
  const [isRefusalButtonDisable, setIsRefusalButtonDisable] = useState(true);
  const [openModalConfirmRefusal, setOpenModalConfirmRefusal] = useState(false);
  const userId = getUserId();

  useEffect(() => {
    setIsRefusalButtonDisable(volumeOrdersIds.length === 0);
  }, [volumeOrdersIds]);

  const mountVolumeOrdersToRefuse = (volumeOrders: any[], additionalDataForRefusal: IAdditionalDataForRefusal) => {
    const volumes = volumeOrders
      .filter(volume => volumeOrdersIds.includes(volume.Id))
      .map(v => ({
        RefuseVolumeOrder: true,
        RefusalAwareness: false, //Visto que a recusa só será feita em massa pelo fornecedor
        volumeOrder: {
          IdUsuario: userId,
          IdPedidoVolume: v.Id,
          Quantity: v.VolumeOrderQuantity,
          ...additionalDataForRefusal
        }
      }));

    return volumes;
  }

  const handleRefuseVolumes = (additionalDataForRefusal: IAdditionalDataForRefusal) => {
    try {
      setLoading(true);
      setOpenModalConfirmRefusal(false);
      const volumesToRefuse = mountVolumeOrdersToRefuse(volumeOrders, additionalDataForRefusal);
      const requests = volumesToRefuse.map(x => ({
        API: `volume-orders/${x.volumeOrder.IdPedidoVolume}:refuse`,
        method: 'post',
        body: x
      }));
      const text = intl.get('volumeOrders.processingRefusal');
      startOperation(requests, text, refresh);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    } 
  }

  return (
    <>
      <ButtonIcon
        buttonIcon={<IconStop />}
        buttonText={intl.get("volumeOrders.refuseVolumes")}
        buttonType="default"
        disabled={isRefusalButtonDisable}
        style={{ width: '166px' }}
        onClick={() => setOpenModalConfirmRefusal(true)}
      />

      {openModalConfirmRefusal && 
        <ModalConfirmRefusal
          open={openModalConfirmRefusal}
          onClose={() => setOpenModalConfirmRefusal(false)}
          onConfirm={handleRefuseVolumes}
        />
      }
    </>
  );
};

export default OrderVolumeRefuse;